export function formatFloatWithTwoDecimals(value: number | string | undefined | null): string {
  const parsedValue = parseFloat(value as string);
  if (isNaN(parsedValue)) {
    return "0.00";
  }
  const [integerPart, decimalPart = ""] = parsedValue.toFixed(2).split(".");
  return `${integerPart}.${decimalPart.padEnd(2, "0")}`;
}
